var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    class: { selected: _vm.isSelected, marked: _vm.isMarked },
    domProps: { innerHTML: _vm._s(_vm.htmlHighlightedLabel) },
    on: {
      mousedown: function ($event) {
        return _vm.$emit("click", _vm.option)
      },
      mousemove: function ($event) {
        return _vm.$emit("hover", _vm.option)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }